import { AD_SERVER_TYPE, adServers, API_KEY } from '../reusableFields'

export const initialValues = {
  [AD_SERVER_TYPE]: adServers.adbutler,
  [API_KEY]: ''
}
